import React from 'react'

import FatButton from "../../../buttons/fat-button/FatButton";
import FileUpload from "../../../../common/FileUpload";
import {CreateSchemaContext} from '../context/CreateSchemaContext';

/**
 * A component which can handle selecting files for upload.
 */
class OntologyFilesUpload extends React.Component<{}, { toggle: boolean }> {

  static contextType = CreateSchemaContext;

  constructor(props: any) {
    super(props);
    this.state = {
      toggle: false
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
  }

  changeHandler(selectedFiles: Array<File>) {
    this.context.uploadOntologies(selectedFiles);
  }

  clickHandler() {
    this.setState({
      toggle: !this.state.toggle
    })
  }

  render() {
    return (
      <>
      <FatButton className="upload-files-btn" icon="upload" title="Upload RDF files"
                 descr="All RDF formats, up to 200MB" clickHandler={this.clickHandler}/>
      <FileUpload toggle={this.state.toggle} changeHandler={this.changeHandler} multiple={true}
                  hidden={true}/>
      </>
    );
  }
}

export default OntologyFilesUpload;
